import { buttonBaseClasses, Components, Theme } from '@mui/material';
import { dateRangePickerDayClasses, pickersDayClasses } from '@mui/x-date-pickers-pro';
import { GetThemeOptions } from '../../../theme/theme';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * MuiPickersDay to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/pickers-day/#classes
 */
const borderRadius = '4px';

export const getMuiPickersDay = (opts: GetThemeOptions): Components<Theme>['MuiPickersDay'] => ({
  styleOverrides: {
    root: ({ theme }) => {
      const selectedColor = opts.panwRebrandStubYear
        ? theme.palette.button.standard.primary.default
        : theme.palette.primary.main;
      const selectedTextColor = opts.panwRebrandStubYear ? theme.palette.button.standard.primary.text : undefined;
      const selectedHoverColor = opts.panwRebrandStubYear ? theme.palette.button.standard.primary.hover : undefined;

      return {
        color: theme.palette.text.primary,
        borderRadius,
        width: '36px',
        height: '24px',

        // Ensure that DateRangePickerDay and PickersDay are identical
        [`&:not(.${dateRangePickerDayClasses.day})`]: {
          margin: '2px !important', // DateRangePickerDay has a transparent 2px border so we need the extra margin
          transform: 'scale(1.1)', // DateRangePickerDay scales to 1.1 to handle overlapping the preview range border
        },

        '&:hover': {
          backgroundColor: theme.palette.background.hover,
        },

        [`&.${pickersDayClasses.dayOutsideMonth}`]: {
          color: theme.palette.text.disabled,
        },

        [`&.${pickersDayClasses.today}`]: {
          borderColor: selectedColor,
        },

        [`&.${pickersDayClasses.selected}`]: {
          background: selectedColor,
          ...(selectedTextColor && { color: selectedTextColor }),
          [`&:hover, &:focus, &.${buttonBaseClasses.focusVisible}`]: {
            ...(selectedHoverColor && { background: selectedHoverColor, border: 'none !important' }),
          },
        },
      };
    },
  },
});
